import {Alert, Animated, Image, Platform, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {
  BodyText,
  ContinueButton,
  HeaderText,
  IconButton,
} from 'src/Modules/CommonView';
import React, {useEffect, useRef, useState} from 'react';
import {addChallengeCoins, addChallengeTickets} from 'src/Utils/huntFunctions';

import GestureRecognizer from 'react-native-swipe-gestures';
import {useDispatch, useSelector} from 'react-redux';

import {markItemVisited} from 'src/Redux/reducers/firstVisit.reducer';
import moment from 'moment';
import {navigationRef} from 'src/Nav/navigationHelpers';

import {updateDataAtPath} from 'src/Utils/fireUtils';
import {useUserId} from '../Hooks/reduxHooks';
import {cloudFlareOptimizeImage} from '../Utils/helpers';
import {mmkvStorage} from '../Utils/mmkvStorage';

// single coin with fox in profile direction
const coinImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648581485_original.png',
  ),
};
const tickets = require('src/Images/standardTicketIcon.png');
const logo = require('src/Images/logo.png');

const prizes = [
  {
    text: '2 Date Night Tickets',
    probability: 1,
    image: tickets,
    tickets: 2,
    theme: 'Date Night',
  },
  {
    text: 'Free Shirt',
    probability: 0,
    image: coinImage,
  },
  {
    text: '10 Coins',
    probability: 50,
    image: coinImage,
    coins: 10,
  },
  {
    text: '-10 Coins',
    probability: 0,
    image: coinImage,
  },
  {
    text: '20 Coins',
    probability: 60,
    image: coinImage,
    coins: 20,
  },
  {
    text: '50 Coins',
    probability: 10,
    image: coinImage,
    coins: 50,
  },
  {
    text: '100 Coins',
    probability: 5,
    image: coinImage,
    coins: 100,
  },
  {
    text: '1000 Coins',
    probability: 1,
    image: coinImage,
    coins: 1000,
  },
  {
    text: 'Spin Again',
    probability: 20,
    image: coinImage,
    coins: 2000,
  },
  {
    text: '15% Off Hunt',
    probability: 70,
    image: coinImage,
    discount: 15,
  },
  {
    text: '20% Off Store',
    probability: 25,
    image: coinImage,
    discount: 20,
  },
  {
    text: 'Free Bar Hunt',
    probability: 3,
    image: tickets,
    tickets: 2,
    theme: 'Standard',
    barHunt: true,
  },
];

function getRandomInt(max) {
  return Math?.floor(Math?.random() * Math?.floor(max));
}

const PrizeWheelModal = () => {
  const {width, height} = useWindowDimensionsSafe();
  const firstVisit = useSelector((state) => state.firstVisit);
  const userId = useUserId();
  const loggedIn = useSelector((state) => state.user?.loggedIn);

  const animatedValue = useRef(new Animated.Value(0)).current;
  const [spinning, setSpinning] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(markItemVisited('hasPressedPrizes'));
  }, []);

  const closeModalOnWin = async (firstWin) => {
    const didReviewPrizeWheel = await mmkvStorage.getBoolean(
      'didReviewPrizeWheel',
    );
    navigationRef.goBack();
    const randomInt = getRandomInt(3);
    const randomRevaluate = randomInt === 1;
    console.log({
      firstWin,
      didReviewPrizeWheel: !!didReviewPrizeWheel,
      randomRevaluate,
      randomInt,
    });
    if (!firstWin && (!didReviewPrizeWheel || randomRevaluate)) {
      mmkvStorage.set('didReviewPrizeWheel', '1');
      setTimeout(() => {
        navigationRef.navigate('CESModal', {
          title: 'Daily Prizes Feedback',
          subTitle:
            'Thank you for doing the daily challenges, please let us know how it went & how we can improve!',
          lr_app_challenge_completion_id: {},
          type: 'r_daily_prizes',
          userId,
          challenged_by_user: 1,
        });
      }, 500);
    }
  };

  const spinWheel = (spinDown = true) => {
    if (!loggedIn) {
      return navigationRef.navigate('LoginModal', {
        message: 'You must log in to spin the prize wheel',
      });
    }

    var winningPrize;
    var prizeIndex;

    if (!firstVisit.hasPressedPrizes) {
      prizeIndex = 5;
      winningPrize = prizes[prizeIndex]; //50 free coins to get them addicted
    } else {
      var totalCount = 0;
      //var currentCount = 0;
      prizeIndex = null;
      prizes?.map?.((prize) => (totalCount = totalCount + prize.probability));
      const winningNumber = getRandomInt(totalCount); //setting the winning number
      var newMax = 0;
      winningPrize;
      prizes?.map?.((prize, index) => {
        newMax = newMax + prize.probability;
        if (winningPrize) {
          //do nothing
        } else if (winningNumber < newMax) {
          prizeIndex = index;
          winningPrize = prizes[prizeIndex];
          //currentCount = newMax;
        } else {
          //currentCount = newMax;
        }
      });
    }

    setSpinning(true);
    Animated?.timing(animatedValue, {
      toValue:
        (spinDown ? 72 : -72) - prizeIndex + (Math?.random() - 0.5) / 1.2,
      duration: __DEV__ ? 5000 : 5000,
      useNativeDriver: Platform.OS !== 'web',
    }).start(() => {
      setTimeout(() => {
        const {text, coins, barHunt, discount, theme, tickets} = winningPrize;
        const firstWin = !firstVisit.hasPressedPrizes;
        if (text == 'Spin Again') {
          setSpinning(false);
        } else {
          const hasSpunPrizeWheelBefore = mmkvStorage.getString(
            'hasSpunPrizeWheelBefore',
          );
          if (!hasSpunPrizeWheelBefore) {
            mmkvStorage.set('hasSpunPrizeWheelBefore', '1');
          } else {
            const currentDate = moment().format('YYYY-MM-DD');
            updateDataAtPath(`users/${userId}/lastSpinDate`, currentDate);
          }

          if (coins == 50) {
            addChallengeCoins(userId, coins || 10);
            Alert.alert(
              'You Won!',
              `Your prize of ${coins} Fox Coins was added to your account.`,
              [
                {
                  text: 'Okay',
                  onPress: () => closeModalOnWin(firstWin),
                },
              ],
            );
          } else if (coins) {
            addChallengeCoins(userId, coins || 10);
            Alert.alert('You Won!', `Claim your prize of ${coins} Fox Coins`, [
              {
                text: 'Claim Later',
                onPress: () => closeModalOnWin(firstWin),
              },
              {
                text: 'Claim Now',
                onPress: () => {
                  closeModalOnWin(firstWin);
                  navigationRef.navigate('FoxShop');
                },
              },
            ]);
          } else if (discount) {
            updateDataAtPath(`users/${userId}`, {
              saleDiscount: parseInt(discount + '') || 20, //int to percent,
              saleEndDate: Date.now() + 24 * 60 * 60 * 1000,
            });
            Alert.alert(
              'You Won!',
              `Claim your prize of ${discount}% off the fox shop in the next 24 hours!`,
              [
                {
                  text: 'Claim Later',
                  onPress: () => closeModalOnWin(firstWin),
                },
                {
                  text: 'Claim Now',
                  onPress: () => {
                    closeModalOnWin(firstWin);
                    navigationRef.navigate('FoxShop');
                  },
                },
              ],
            );
          } else if (barHunt) {
            addChallengeTickets(userId, tickets, 'Standard');
            Alert.alert(
              'You Won Bar Hunt Tickets!',
              `Claim your prize of ${tickets} tickets any time in the next 2 weeks`,
              [
                {
                  text: 'Claim Later',
                  onPress: () => closeModalOnWin(firstWin),
                },
                {
                  text: 'Claim Now',
                  onPress: () => {
                    closeModalOnWin(firstWin);
                    navigationRef.navigate('LandingPage');
                  },
                },
              ],
            );
          } else if (tickets) {
            addChallengeTickets(userId, tickets, theme);
            Alert.alert(
              'You Won Tickets!',
              `Claim your prize of ${tickets} tickets any time in the next 2 weeks`,
              [
                {
                  text: 'Claim Later',
                  onPress: () => closeModalOnWin(firstWin),
                },
                {
                  text: 'Claim Now',
                  onPress: () => {
                    closeModalOnWin(firstWin);
                    navigationRef.navigate('LandingPage');
                  },
                },
              ],
            );
          }
        }
      }, 500);
    });
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: 'transparent',
        alignItems: 'center',
      }}>
      <View
        style={{
          width: width,
          marginTop: 30,
          borderRadius: 5,
          height: height - 100,
          backgroundColor: 'white',
          alignItems: 'center',
          overflow: 'hidden',
        }}>
        <HeaderText
          text={
            !firstVisit.hasPressedPrizes
              ? `Let's Roam Prize Wheel`
              : 'Congratulations'
          }
          center
          fullWidth={310}
        />
        <BodyText
          text={
            !firstVisit.hasPressedPrizes
              ? 'Every time you finish your daily challenges, you get to spin the wheel. The first spin is on us! Spin it up or down to claim your prize!'
              : 'You have finished all the daily activities and have earned the chance to spin the prize wheel! Spin it up or down to claim your prize!'
          }
        />
        <IconButton
          handlePress={() => navigationRef.goBack(null)}
          right
          color={global?.color?.gray3}
        />
        <ContinueButton
          text={'Spin The Wheel'}
          width={220}
          renderElement={!spinning}
          background={global?.color?.orange}
          handlePress={() => spinWheel()}
        />
        <GestureRecognizer
          onSwipeUp={() => {
            if (!spinning) {
              spinWheel(false); //up spin
            }
          }}
          onSwipeDown={() => {
            if (!spinning) {
              spinWheel(true); //up spin
            }
          }}
          onSwipeLeft={() => {
            if (!spinning) {
              spinWheel(false); //up spin
            }
          }}
          onSwipeRight={() => {
            if (!spinning) {
              spinWheel(true); //up spin
            }
          }}
          style={{
            height: 500,
            width: 500,
            position: 'absolute',
            top: 160,
            left: -200,
          }}
          config={{
            velocityThreshold: 0.03,
            directionalOffsetThreshold: 80,
          }}>
          <View
            style={{
              marginTop: 10,
              height: 500,
              width: 500,
              borderRadius: 250,
              position: 'absolute',
              top: 0,
              left: 0,
              overflow: 'hidden',
            }}>
            <Animated.View
              style={{
                backgroundColor: global?.color?.white,
                height: 500,
                width: 500,
                borderRadius: 250,
                position: 'absolute',
                top: 0,
                left: 0,
                transform: [
                  {
                    rotate: animatedValue.interpolate({
                      inputRange: [0, 72],
                      outputRange: ['0deg', '2160deg'],
                    }),
                  },
                ],
              }}>
              {prizes?.map?.((prize, index) => {
                return (
                  <PrizeSlice
                    key={`prizeslice_${index}`}
                    prizeText={prize.text}
                    color={
                      index % 2 == 0
                        ? global?.color?.gray1
                        : global?.color?.blue
                    }
                    image={prize.image}
                    rotation={index * 30}
                    index={index}
                  />
                );
              })}
            </Animated.View>
          </View>
        </GestureRecognizer>
        <View
          style={{
            position: 'absolute',
            width: 80,
            height: 80,
            backgroundColor: global?.color?.orange,
            left: 10,
            top: 380,
            borderRadius: 40,
            elevation: 3,
            shadowColor: 'black',
            shadowRadius: 10,
            alignItems: 'center',
            justifyContent: 'center',
            shadowOffset: {width: 0, height: 0},
          }}>
          <Image style={{width: 35, height: 50}} source={logo} />
        </View>
        <View
          style={{
            width: 0,
            height: 20,
            position: 'absolute',
            backgroundColor: 'transparent',
            top: 405,
            left: 245 + (Platform.OS == 'android' ? 40 : 0),
            borderRightWidth: Platform.OS == 'android' ? 40 : 80,
            borderLeft: 0,
            borderTopWidth: 14,
            borderBottomWidth: 14,
            borderRightColor: global?.color?.orange,
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        />
        <View
          style={{
            height: 28,
            width: 28,
            borderRadius: 14,
            position: 'absolute',
            backgroundColor: global?.color?.orange,
            top: 405,
            left: 314,
          }}
        />
      </View>
    </SafeAreaView>
  );
};

const PrizeSlice = ({prizeText, rotation = 0, color, image}) => {
  return (
    <View
      style={{
        height: 500,
        width: 500,
        alignItems: 'flex-end',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'visible',
      }}
      transform={[{rotate: `${rotation}deg`}]}>
      <View
        style={{
          width: 0,
          height: 130,
          // backgroundColor: 'green',
          borderStyle: 'solid',
          borderRightWidth: Platform.OS == 'android' ? 250 : 250,
          borderLeft: 0,
          borderTopWidth: 130 / 2,
          borderBottomWidth: 130 / 2,
          borderRightColor: color,
          borderTopColor: 'transparent',
          borderBottomColor: 'transparent',
        }}
      />
      <View
        style={{
          position: 'absolute',
          color: 'white',
          backgroundColor: 'transparent',
          justifyContent: 'center',
          top: 200,
          bottom: 200,
          left: 320,
          right: 5,
          paddingLeft: 50,
        }}>
        <BodyText
          text={prizeText}
          textStyle={{color: 'white', fontWeight: '500'}}
        />
        <Image
          source={image}
          style={{height: 50, width: 50, position: 'absolute'}}
        />
      </View>
    </View>
  );
};

export default PrizeWheelModal;
